import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, CuentaService, PersonaService, GastoService, ComunidadService, UnidadFuncionalService, PedidoService, TenantService, TipoMovimientoService, ContratoService, EstadoService, AlicuotaIvaService, MonedaService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, Movimiento, Cuenta, Persona, Gasto, Comunidad, UnidadFuncional, PedidoItemDto, MedioPagoConstants, DialogConfirmRequest, DialogConfirmResponse, EstadoConstants, DialogCuentaSearchComponentRequestDto, DialogCuentaSearchComponentResponseDto, LocalStorageKeys, SaveMovimientoRequestDto, SaveCuentaDto, TenantFeatureFlags, SearchTipoMovimientoRequest, TipoMovimiento, Contrato, SearchEstadoRequest, Estado, SearchMonedaRequest, SearchAlicuotaIvaRequest, Moneda, AlicuotaIva } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCuentaSearchComponent } from '../cuenta/components/dialogCuentaSearch.component';

@Component({
  selector: 'app-miMovimientoView',
  templateUrl: './miMovimientoView.component.html',
  styleUrls: []
})

export class MiMovimientoViewComponent implements OnInit {
  formGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isCuentaSearching: boolean = false;
  isGastoSearching: boolean = false;
  isGastoComunidadSearching: boolean = false;
  isGastoUfSearching: boolean = false;
  isPagosSearching: boolean = false;
  isDeudasSearching: boolean = false;
  isPersonaSearching: boolean = false;
  isPedidoItemsSearching: boolean = false;
  isContratoSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isRejecting: boolean = false;
  hasMiMovimientoViewPermission: boolean = false;
  isGenerandoRecibo: boolean = false;
  isSaving: boolean = false;
  isFileAttaching: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isAttachmentSearching: boolean = false;

  canEdit: boolean = false;
  canCancel: boolean = false;
  canView: boolean = false;
  canChangeState: boolean = false;
  esPagoConCreditoEnCuenta: boolean = false;

  newFileDescripcion: string = "";
  msgError: string = "";

  montoIva: number = 0;
  montoTotal: number = 0;

  item: Movimiento;
  pagosList: Movimiento[];
  deudasList: Movimiento[];
  tipoMovimientoList: TipoMovimiento[];
  estadoList: Estado[];
  monedaList: Moneda[];
  alicuotaIvaList: AlicuotaIva[];

  itemGasto: Gasto;
  itemGastoComunidad: Comunidad;
  itemGastoUf: UnidadFuncional;
  itemPedido: PedidoItemDto;
  itemContrato: Contrato;

  cuentaImputada: Cuenta;
  cuentaDetalle: Cuenta;
  persona: Persona;
  isRosbaco: boolean = false;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    private datePipe: DatePipe,
    private router: Router,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private gastoService: GastoService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private tipoMovimientoService: TipoMovimientoService,
    private cuentaService: CuentaService,
    private personaService: PersonaService,
    private pedidoService: PedidoService,
    private contratoService: ContratoService,
    private estadoService: EstadoService,
    private movimientoService: MovimientoService) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.MIS_MOVIMIENTOS_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = true;
            if (this.canChangeState || this.canEdit || this.canView)
              this.loadView();
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();

    this.buildForm();

    this.loadEntity();

    this.getEstados();
    this.getAlicuotaIva();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'FechaMovimiento': [new Date(), Validators.required],
      'FechaVencimiento': [new Date()],
      'EstadoId': [null, Validators.required],
      // 'CuentaDetalleId': [null],
      'TipoMovimientoId': [0, Validators.required],
      // 'MedioPagoId': [null],
      'AlicuotaIvaId': [null],
      'Moneda': [null],
      'MontoBase': [0, Validators.required],
      'MontoPercepciones': [0, Validators.required],
      'Detalle': [null, [Validators.required, Validators.maxLength(100)]],
      'Observacion': [null, Validators.maxLength(300)],
      'NroComprobante': [null, Validators.maxLength(100)],

      'EsRecurrente': [false, Validators.required],
      'PeriodicidadRecurrencia': [null],

      //Solo para deudas
      // 'CantidadCuotas': [1, Validators.min(1)],
      // 'FechaInicioCuota': [new Date()],
      // 'DiasRepeticionCuotas': [30],
      // 'PorcentajeAjusteCuota': [0, [Validators.min(0), Validators.max(100)]],
      // 'AplicarAjusteIncremental': [false],
    });
  }

  isProcessing() {
    return (this.isSearching || this.isGenerandoRecibo || this.isRejecting || this.isSaving);
  }

  getEstados() {
    if (!this.canChangeState)
      return false;

    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result?.filter(f => f.Id != EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO);
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;

      if (this.canEdit)
        this.formGroup.get("Moneda")?.setValue(this.monedaList?.find(f => f.Id == this.item?.MonedaId));
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;

      this.calcularMontos();
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, this.item?.TipoMovimientoSigno, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getErrorFechaMovimiento() {
    return this.formGroup.get('FechaMovimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorFechaVencimiento() {
    return this.formGroup.get('FechaVencimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId() {
    return this.formGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId() {
    return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId() {
    return this.formGroup.get('Moneda')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoBase() {
    return this.formGroup.get('MontoBase')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoPercepciones() {
    return this.formGroup.get('MontoPercepciones')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErroNroComprobante() {
    var v = this.formGroup.get('NroComprobante');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMedioPagoId() {
    return this.formGroup.get('MedioPagoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          this.isSearching = true;
          this.movimientoService.get(id).subscribe(data => {
            this.isSearching = false;
            if (data != null && data.Success) {
              this.item = data.Result;

              if (this.item != null && this.item.Id > 0) {

                this.getMonedas();
                this.getTiposMovimientos();

                this.loadAttachments(this.item.Id);

                this.loadCuenta(this.item.CuentaImputadaId, false);
                this.loadCuenta(this.item.CuentaDetalleId, true);

                this.loadPagos();
                this.loadDeudas();

                this.loadGasto();
                this.loadPedidoItems();
                this.loadContratos();

                this.esPagoConCreditoEnCuenta = (this.item.MedioPagoId == MedioPagoConstants.CreditoEnCuenta);

                this.formGroup.patchValue(this.item);
                this.calcularMontos();
              }
              else {
                this.canView = false;
                this.msgError = "No se encontró el movimiento seleccionado.";
              }
            }
            else {
              this.canView = false;
              this.msgError = "Ocurrió un error al intentar obtener los datos del movimiento.";
            }
          },
          (err: HttpErrorResponse) => {
            this.canView = false;
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else {
          this.canView = false;
          this.msgError = "Item no válido.";
        }
      }
      else {
        this.canView = false;
        this.msgError = "Debe seleccionar un movimiento.";
      }
    });
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.movimientoService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadCuenta(cuentaId: number | null, cargaCuentaDetalle: boolean = false) {
    if (cuentaId != null && cuentaId > 0) {
      this.isCuentaSearching = true;
      this.cuentaService.get(cuentaId).subscribe(data => {
        this.isCuentaSearching = false;

        if (cargaCuentaDetalle)
          this.cuentaDetalle = data?.Result;
        else
          this.cuentaImputada = data?.Result;
      },
      (err: HttpErrorResponse) => {
        this.isCuentaSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadPagos() {

    if (this.item != null && this.item.TipoMovimientoSigno !== null && this.item.TipoMovimientoSigno < 0) {
      this.isPagosSearching = true;
      this.movimientoService.getPagos(this.item.Id).subscribe(data => {
        this.isPagosSearching = false;
        this.pagosList = data?.Result;
      },
      (err: HttpErrorResponse) => {
        this.isPagosSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadDeudas() {

    if (this.item != null && this.item.TipoMovimientoSigno !== null && this.item.TipoMovimientoSigno > 0) {
      this.isDeudasSearching = true;
      this.movimientoService.getDeudas(this.item.Id).subscribe(data => {
        this.isDeudasSearching = false;
        this.deudasList = data?.Result;
      },
      (err: HttpErrorResponse) => {
        this.isDeudasSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadGasto() {
    if (this.item.GastoId !== null && this.item?.GastoId > 0) {
      this.isGastoSearching = true;
      this.gastoService.get(this.item?.GastoId).subscribe(data => {
          this.isGastoSearching = false;
          if (data != null && data.Success) {
            this.itemGasto = data.Result;

            if (this.itemGasto != null && this.itemGasto.Id > 0) {
              this.loadGastoData();
            }
            else
              this.msgError = "No se encontró el gasto seleccionado.";
          }
          else
            this.msgError = "Ocurrió un error al intentar obtener los datos del gasto.";
      },
      (err: HttpErrorResponse) => {
        this.isGastoSearching = false;
        this.sharedFunctions.handleError(err);
      })
    }
  }

  loadGastoData() {
    if (this.itemGasto.UnidadFuncionalId != null && this.itemGasto.UnidadFuncionalId > 0) {
      this.isGastoUfSearching = true;
      this.unidadFuncionalService.get(this.itemGasto.UnidadFuncionalId).subscribe(data => {
        this.isGastoUfSearching = false;
        if (data != null && data.Success) {
          this.itemGastoUf = data.Result;
          this.loadGastoComunidad(this.itemGastoUf.ComunidadId);
        }
      },
      (err: HttpErrorResponse) => {
        this.isGastoUfSearching = false;
        this.sharedFunctions.handleError(err);
      })
    }

    if (this.itemGasto.ComunidadId != null && this.itemGasto.ComunidadId > 0)
      this.loadGastoComunidad(this.itemGasto.ComunidadId);
  }

  loadGastoComunidad(comunidadId) {
    this.isGastoComunidadSearching = true;
    this.comunidadService.get(comunidadId).subscribe(data => {
      this.isGastoComunidadSearching = false;
      if (data != null && data.Success)
        this.itemGastoComunidad = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isGastoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadCuentaPersona(personaId) {

    if (personaId != null && personaId > 0) {
      this.isPersonaSearching = true;
      this.personaService.get(personaId).subscribe(data => {
        this.isPersonaSearching = false;
        this.persona = data?.Result;
      },
      (err: HttpErrorResponse) => {
        this.isPersonaSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadPedidoItems() {
    if (this.item?.PedidoItemId !== null && this.item?.PedidoItemId > 0) {
      this.isPedidoItemsSearching = true;
      this.pedidoService.getPedidoItemById(this.item?.PedidoItemId).subscribe(data => {
        this.isPedidoItemsSearching = false;
        if (data.Success)
          this.itemPedido = data?.Result;
      },
      (err: HttpErrorResponse) => {
        this.isPedidoItemsSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadContratos() {
    if (this.item?.ContratoId !== null && this.item?.ContratoId > 0) {
      this.isContratoSearching = true;
      this.contratoService.get(this.item?.ContratoId).subscribe(data => {
        this.isContratoSearching = false;
        if (data.Success) {
          this.itemContrato = data?.Result;

          if (this.itemContrato != null && this.itemContrato.Id > 0) {
            this.loadContratoPersonas(this.itemContrato.Id);
            this.loadContratoUnidadesFuncionales(this.itemContrato.Id);
          }
        }
      },
      (err: HttpErrorResponse) => {
        this.isContratoSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  loadContratoPersonas(id) {
    // this.isPersonasSearching = true;
    this.contratoService.getPersonas(id).subscribe(data => {
      // this.isPersonasSearching = false;
      if (data.Success)
        this.itemContrato.Personas = data.Result;
    },
    (err: HttpErrorResponse) => {
      // this.isPersonasSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  loadContratoUnidadesFuncionales(id) {
    // this.isUnidadesFuncionalesSearching = true;
    this.contratoService.getUnidadesFuncionales(id).subscribe(data => {
      // this.isUnidadesFuncionalesSearching = false;
      this.itemContrato.UnidadesFuncionales = data.Result;
    },
    (err: HttpErrorResponse) => {
      // this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  calcularMontos() {
    var importeBase = (this.formGroup.get("MontoBase")?.value ?? 0);
    var importePercepciones = (this.formGroup.get("MontoPercepciones")?.value ?? 0) * ((this.item?.TipoMovimientoSigno ?? 0) > 0 ? -1 : 1);

    var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    if (alicuota != null && alicuota.Id > 0)
      this.montoIva = (importeBase * (alicuota.Porcentaje / 100));
    else
      this.montoIva = 0;

    this.montoTotal = importeBase + this.montoIva + importePercepciones;
  }

  onCancel() {
    this.location.back();
  }

  getGridEstadoBackgroundColor(item: any) {
    return (item != null && item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO ? 'indianred' : 'black');
  }

  viewMovimiento(id: number) {
    if (id != null && id > 0)
      this.router.navigate(['mi-movimiento-view', id]);
    else
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar con la operación", "Error");
  }

  onReject() {
    if (this.item == null || this.item.Id == null || this.item.Id <= 0 || !this.item.PuedeRechazar)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        null,
        "¿Está seguro que desea cancelar el movimiento?<br/><br/>" +
          "<b>Una vez cancelado, el movimiento no podrá volver a ser restaurado.</b>",
        "Sí, cancelar de todas formas",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isRejecting = true;
        this.movimientoService.cancelar(this.item.Id).subscribe(data => {
          this.isRejecting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se canceló correctamente el movimiento!", "Operación Exitosa!");

            setTimeout(() => this.sharedFunctions.reloadCurrentRoute(), 500);
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isRejecting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  getEstadoBackgroundColor() {
    return (this.item != null && this.item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO ? 'indianred' : 'white');
  }

  onGenerarReciboPago() {
    if (this.item.CuentaDetalleId == null || this.item.CuentaDetalleId <= 0) {
      var mensaje = this.isRosbaco ? "" : " de Pago"
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Impresión de Recibo " + mensaje,
          "El movimiento no tiene cargado los datos del origen de fondos. ¿Desea cargarlos ahora para poder imprimir el recibo?",
          "Sí, voy a cargar los datos",
          "No, cancelar la impresión"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted)
          this.doCargaCuentaDetalle();
      });
    }
    else
      this.doGeneracionReciboPago();
  }

  doCargaCuentaDetalle() {
    this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
      if (dataTenant != null && dataTenant.Success) {

        //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
        const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
          width: '90%',
          data: new DialogCuentaSearchComponentRequestDto(dataTenant.Result, true, true, false, false, false, null, null, null)
        });

        dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
          if (result.Item != null && !result.Cancelled) {
            this.cuentaDetalle = result.Item;
            this.onGuardar(true);
          }
        });

      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error intentando ejecutar la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err, true);
    })
  }

  doGeneracionReciboPago() {
    this.isGenerandoRecibo = true;
    this.movimientoService.generarReciboPago(this.item.Id).subscribe((data: Blob) => {
      this.isGenerandoRecibo = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReciboPago_" + this.item.Id + "_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + ".pdf";
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isGenerandoRecibo = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGuardar(crearReciboPago: boolean = false) {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveMovimientoRequestDto(
      this.item.Id,

      (this.cuentaImputada?.Id ?? 0),
      (this.cuentaImputada != null ? new SaveCuentaDto((this.cuentaImputada?.Id ?? 0), this.cuentaImputada.Codigo, (this.cuentaImputada.MonedaId ?? this.item.MonedaId), this.cuentaImputada.BancoId,
        this.cuentaImputada.PersonaId, this.cuentaImputada.ProveedorId, this.cuentaImputada.ComunidadId, this.cuentaImputada.ConsorcioId, this.cuentaImputada.UnidadFuncionalId,
        this.cuentaImputada.NumeroCuenta, this.cuentaImputada.Titular, this.cuentaImputada.Alias, this.cuentaImputada.ClaveBancaria, (this.cuentaImputada?.Activo ?? true),
        (this.cuentaImputada?.EsCuentaCorrienteInterna ?? true)) : null),

      (this.cuentaDetalle?.Id ?? 0),
      (this.cuentaDetalle != null ? new SaveCuentaDto((this.cuentaDetalle?.Id ?? 0), this.cuentaDetalle.Codigo, (this.cuentaDetalle.MonedaId ?? this.item.MonedaId), this.cuentaDetalle.BancoId,
        this.cuentaDetalle.PersonaId, this.cuentaDetalle.ProveedorId, this.cuentaDetalle.ComunidadId, this.cuentaDetalle.ConsorcioId, this.cuentaDetalle.UnidadFuncionalId,
        this.cuentaDetalle.NumeroCuenta, this.cuentaDetalle.Titular, this.cuentaDetalle.Alias, this.cuentaDetalle.ClaveBancaria, (this.cuentaDetalle?.Activo ?? true),
        (this.cuentaDetalle?.EsCuentaCorrienteInterna ?? true)) : null),

      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      []
    );

    r = {
      ...r,
      ...this.formGroup.getRawValue(),
      ...{
        MonedaId: this.formGroup.get("Moneda")?.value?.Id,
        Adjuntos: this.item?.Adjuntos
      }
    };

    this.isSaving = true;
    this.movimientoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success) {
        if (crearReciboPago && data.Result.CuentaDetalleId) {
          this.item.CuentaDetalleId = data.Result.CuentaDetalleId;
          this.loadCuenta(data.Result.CuentaDetalleId, true);
          this.doGeneracionReciboPago();
        }
        else {
          this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
          this.sharedFunctions.reloadCurrentRoute();
        }
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error guardando los datos del origen de fondos", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.movimientoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                data.Result.Archivos[i].Descripcion = this.newFileDescripcion;
                this.item.Adjuntos.push(data.Result.Archivos[i]);
                this.newFileDescripcion = "";
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  openDialogCuentaImputadaSearch() {
    if (this.isProcessing())
        return;

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto
        (
          this.tenantFeatureFlags,
          false, false, true, true, true,
          this.formGroup.get("Moneda")?.value?.Id, this.formGroup.get("Moneda")?.value?.Codigo,
          null
        )
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled && result.Item) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputada = result.Item;
      }
    });
  }

  openDialogCuentaDetalleSearch() {
    if (this.isProcessing())
        return;

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, true, true, false, false, false, null, null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled &&  result.Item) {
        var cargoCuenta = this.checkCuentaDetalle(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaDetalle = result.Item;
      }
    });
  }

  checkCuentaImputada(datosCuenta) {
    return (datosCuenta != null && ((datosCuenta.ComunidadId ?? 0) + (datosCuenta.ConsorcioId ?? 0) + (datosCuenta.UnidadFuncionalId ?? 0) > 0));
  }

  checkCuentaDetalle(datosCuenta) {
    if (datosCuenta == null)
      return false;

    if ((datosCuenta.ProveedorId ?? 0) + (datosCuenta.PersonaId ?? 0) > 0)
      return true;
    else {
      if ((datosCuenta.PersonaId ?? 0) == 0 && datosCuenta.Persona != null)
        return true;
    }

    return false;
  }

  esEstadoPendiente() {
    return this.formGroup?.get('EstadoId')?.value == EstadoConstants.ESTADO_MOVIMIENTO_PENDIENTE;
  }
}
